import { useSelector } from 'react-redux'
import UserEditForm    from '../../components/Users/UserEditForm'
import MainLayout      from '../../layouts/MainLayout'

export default function UsersAdd(): JSX.Element {
  const currentUser: any = useSelector( ( state: any ): any => state.currentUser.user )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { currentUser?.admin && <UserEditForm /> }

          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
